import { useHall } from '@/contexts/HallProvider'
import { useAblyTypedPubSub } from '../use-ably'
import { useAzureTts } from '@/contexts/AzureTtsProvider'
import { useFlowNotes } from '@/contexts/FlowNotesProvider'
import { usePoll } from '@/contexts/PollProvider'
import { useHallUsers } from '@/contexts/HallUsersProvider'

export const useResetPubSub = () => {
  const { resetHall, hall } = useHall()
  const { cleanup } = useAzureTts()
  const { resetFlowNotes } = useFlowNotes()
  const { resetPoll } = usePoll()
  const { resetHallUsers, currentUser } = useHallUsers()

  const { publish } = useAblyTypedPubSub<string>('RESET_HALL', async ({ data }) => {
    resetHall(data.metadata)
    cleanup()
    resetFlowNotes(data.flowNotes)
    resetPoll()
    resetHallUsers()

    localStorage.removeItem(`ballot-draft-${hall?.id}-${currentUser?.id}`)
  })

  return { reset: publish }
}
